<template>
    <div class="col-12">
        <hr/>
        <OtherEntityRow
            v-for="(item, index) in otherEntities"
            :key="index"
            :item="item"
            :unique-id="generateId()"
            :disabled="disabled"
            :other-entities-types="availableOtherEntitiesTypes(index)"
            :type="type"
            :errors="errors"
            :contractors="availableContractors(index)"
            :requiredFields="requiredFields"
            :originalCompany="originalCompany"
            :itemIndex="index"
            @inputs="$emit('otherEntityInput', {index, ...$event})"
            @removeOtherEntity="$emit('removeOtherEntity', index)"
            >

        </OtherEntityRow>

        <button v-if="!disabled" type="button" class="btn btn-primary" @click="$emit('addNewOtherEntity')">
            {{ __('add_other_entity') }}
        </button>
    </div>

</template>
<script>
import OtherEntityRow from "./OtherEntityRow";
import hasRequiredFields from "../../mixins/hasRequiredFields";
import hasErrors from "../../mixins/hasErrors";
export default {
    components: {OtherEntityRow},
    mixins: [hasRequiredFields, hasErrors],
    data() {
        return {
        };
    },
    props: {
        contractors: {
            type: Array,
            default: () => [],
        },
        otherEntitiesTypes:{
            type: Array,
            default: () => [],
        },
        otherEntities:{
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: Object,
            required: true,
        },
        originalCompany: {
            type: Object,
            default: () => {},
        },
    },
    methods:{
        generateId() {
            return Math.random().toString(36).substr(2, 9); // Prosta losowa wartość
        },
        availableOtherEntitiesTypes(indexToSkip){
            const result = [];
            this.otherEntities.forEach((obj, index) => {
                if (obj.hasOwnProperty('document_other_entity_type_id')) {
                    result.push(parseInt(obj.document_other_entity_type_id));
                }
            });
            const availableEntities = [];

            this.otherEntitiesTypes.forEach((obj, index) => {
                // Pomijamy obiekt, jeśli jego klucz (indeks) odpowiada indexToSkip
                if (obj.hasOwnProperty('id')) {
                    if (obj.in_droplist == 'always') {
                        availableEntities.push(obj);
                    } else if (!result.includes(obj.id) || this.otherEntities[indexToSkip].document_other_entity_type_id == obj.id) {
                        availableEntities.push(obj);
                    }
                }
            });
            return availableEntities;
        },
        availableContractors(indexToSkip){
            return this.contractors;
        },
    }

}
</script>
